<p-confirmDialog acceptButtonStyleClass="p-button-danger" rejectButtonStyleClass="p-button-secondary p-button-outlined" />
<p-toast position="top-center" />
@if (auth.isAuthenticated() && !standalonePage()) {
  <div class="app-shell">
    <app-sidebar />
    <div class="main-column">
      <app-shared-header />
      <app-error-banner />
      <app-suspended-banner />
      <app-workflow-notice-banner />
      <main class="page">
        <router-outlet />
      </main>
    </div>
  </div>
} @else {
  <div class="public-bar">
    <app-language-switch />
  </div>
  <app-error-banner />
  <main class="page">
    <router-outlet />
  </main>
}
